import script from "./CardItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardItem.vue?vue&type=script&setup=true&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=79452294&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79452294"]])

export default __exports__